/*
Door Hinges

  --type <string:: enum> | ['Five-Knuckle', 'Top Pivot', 'Bottom Pivot', 'Intermediate Pivot', 'Top & Bottom Pivot']
*/
import { type } from '@/modules/standardItems/schemas/baseFilters'
import hardwareFilters from '@/modules/standardItems/schemas/hardware/filters'

export default [
  ...hardwareFilters,
  type()
]
